import { CALILIO_NODE_ENV } from '@shared/constants/env';

const testEnvs = ['develop', 'staging'];

export const config = {
  APP_ENV: import.meta.env.VAROSA_NODE_ENV,
  API_ENDPOINT: import.meta.env.VAROSA_API_ENDPOINT + '/graphql',
  MEDIA_UPLOAD_ENDPOINT: import.meta.env.VAROSA_API_ENDPOINT,
  DOCUMENT_DOWNLOAD_ENDPOINT: import.meta.env.VAROSA_API_ENDPOINT + '/transliterate/private/v1',
  SUBSCRIPTION_ENDPOINT: import.meta.env.VAROSA_API_ENDPOINT + '/graphql/ws',
  HOME_URL: import.meta.env.VAROSA_HOME_URL,
  RECAPTCHA_KEY: import.meta.env.VAROSA_RECAPTCHA_KEY,
  PAYMENT_SITE: import.meta.env.VAROSA_PAYMENT_SITE,
  PAYMENT_PUBLISHABLE_KEY: import.meta.env.VAROSA_PAYMENT_PUBLISHABLE_KEY,
  TWILIO_REFRESH_MS: import.meta.env.VAROSA_TWILIO_TOKEN_REFRESH_MS,
  IS_TEST_ENV: testEnvs.includes(import.meta.env.VAROSA_NODE_ENV),
  IS_PRODUCTION: import.meta.env.VAROSA_NODE_ENV === CALILIO_NODE_ENV.PRODUCTION,
  IS_UAT: import.meta.env.VAROSA_NODE_ENV === CALILIO_NODE_ENV.UAT,
  IS_STAGING: import.meta.env.VAROSA_NODE_ENV === CALILIO_NODE_ENV.STAGING,
  IS_DEVELOP: import.meta.env.VAROSA_NODE_ENV === CALILIO_NODE_ENV.DEVELOP,
  DEVICE_IDENTITY_KEY: import.meta.env.VAROSA_DEVICE_IDENTITY_KEY,
  DEVICE_IDENTITY_PROXY: import.meta.env.VAROSA_DEVICE_IDENTITY_PROXY,
  VAROSA_OLD_DESIGN: import.meta.env.VAROSA_OLD_DESIGN,
  AWS_USER_POOL_ID: import.meta.env.VAROSA_AWS_USER_POOL_ID,
  AWS_USER_POOL_CLIENT_ID: import.meta.env.VAROSA_AWS_USER_POOL_CLIENT_ID,
  AWS_OAUTH_DOMAIN: import.meta.env.VAROSA_AWS_OAUTH_DOMAIN,
  AWS_OAUTH_REDIRECT_SIGN_IN: import.meta.env.VAROSA_OAUTH_REDIRECT_SIGN_IN,
  AWS_OAUTH_REDIRECT_SIGN_OUT: import.meta.env.VAROSA_OAUTH_REDIRECT_SIGN_OUT,
  SENTRY_DSN: import.meta.env.VAROSA_SENTRY_DSN,
  APP_VERSION: import.meta.env.VAROSA_APP_VERSION,
  // firebase
  VAROSA_FIREBASE_API_KEY: import.meta.env.VAROSA_NOTIFICATION_API_KEY,
  VAROSA_FIREBASE_AUTH_DOMAIN: import.meta.env.VAROSA_NOTIFICATION_AUTH_DOMAIN,
  VAROSA_FIREBASE_PROJECT_ID: import.meta.env.VAROSA_NOTIFICATION_PROJECT_ID,
  VAROSA_FIREBASE_STORAGE_BUCKET: import.meta.env.VAROSA_NOTIFICATION_STORAGE_BUCKET,
  VAROSA_FIREBASE_MESSAGING_SENDER_ID: import.meta.env.VAROSA_NOTIFICATION_MESSAGING_SENDER_ID,
  VAROSA_FIREBASE_APP_ID: import.meta.env.VAROSA_NOTIFICATION_APP_ID,
  VAROSA_FIREBASE_MEASUREMENT_ID: import.meta.env.VAROSA_NOTIFICATION_MEASUREMENT_ID,
  VAROSA_FIREBASE_VAPID_KEY: import.meta.env.VAROSA_NOTIFICATION_VAPID_KEY,
};
